import React, { Component } from "react";

import "./dashedLineBreakHeader.css";

export default class DashedLineBreakHeader extends Component {
  render() {
    return (
      <div
        className={`dashedLineBreakHeader ${
          this.props.first === true ? "first" : ""
        }`}
      >
        <h1>{this.props.title}</h1>
        <div className="dashedLineBreak" />
      </div>
    );
  }
}
